import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerUrlService } from './server-url.service';

@Injectable({
  providedIn: 'root'
})
export class EspecialidadesService {

  constructor(
    private http: HttpClient,
    private serverUrlService: ServerUrlService  
  ) { }

  consultaEspecialidades() {
    return this.http.get(`${this.serverUrlService.getUrl()}/especialidades`);
  }

  postConsultaEspecialidades(empresaId: number) {
    return this.http.post(`${this.serverUrlService.getUrl()}/especialidades/get-por-empresa`, {
      empresaid: empresaId
    });
  }
}
